/* eslint-disable no-unused-vars */
export enum BadRequestMessages {
  MSSING_X_CORRELATIONID = 'Missing x-correlationId header',
}
